import styled from 'styled-components'
import React, { useState, useEffect } from 'react'
import { bool, func, string } from 'prop-types'
import CVVInput from '../CVVInput/CVVInput'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Button from '@taglivros/oef_componentes/build/components/button'
import Loader from '@taglivros/oef_componentes/build/components/loader'
import Modal from '@taglivros/oef_componentes/build/components/modal'
import Toast from '@taglivros/oef_componentes/build/components/toast'

import { TITULO, DESCRICAO, FRASE_APOIO_CVV } from './constantsModalCVV'
const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 100%;

  p {
    white-space: pre-line;
  }
  
  .toast__close {
    height: 15px;
    right: 25px;
    width: auto;
  }

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    .toast {
      margin-bottom: 15px;
    }
  }
`

const Titulo = styled.h3`
  color: ${StyleGuide.cores.cinza500};
  ${StyleGuide.boldFonte};
  margin: 12px 0;
`

const Descricao = styled.p`
  color: ${StyleGuide.cores.cinza500};
  ${StyleGuide.tipografia.textoPequeno};
  margin: 0 auto;
  max-width: 320px;

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    max-width: 100%;
  }
`

const TextoCVV = styled.p`
  color: ${StyleGuide.cores.cinza400};
  margin-bottom: 35px;
`

const WrapperButtonError = styled.div`
  margin: 40px auto 0;
  width: 100%;
  display: flex;
  button {
      flex: 1
    }
`

const WrapperButton = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 40px auto 0;
  width: 90%;

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    margin: 10px auto 20px;
    width: 100%;
    button {
      flex: 1
    }
  }
`

const LoadingWrapper = styled.div`
  align-items: center;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 10px;
  display: flex;
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 2;
`

const ModalCVV = ( { acaoPrimariaTitulo, acaoSecundariaTitulo, errosAutoCobranca, fecharModal, limparErros, onClickAcaoPrimaria, onClickAcaoSecundaria, open, loading } ) => {
  // eslint-disable-next-line react/hook-use-state
  const [ CVV, setCVV ] = useState( null )
  const [ toast, setToast ] = useState( null )
  const [ valido, setValido ] = useState( false )
  useEffect( () => {
    if ( errosAutoCobranca ) {
      setToast( {
        'funcao': () => {
          setToast( false )
          limparErros()
        },
        'message': errosAutoCobranca.message,
        'show': true
      } )
    }
  }, [ errosAutoCobranca ] )

  return (
    <Modal
      altura="auto"
      largura="450px"
      onShowModal={ fecharModal }
      show={ open }
    >
      { loading ?
        <LoadingWrapper>
          <Loader isCenter />
        </LoadingWrapper> : null}

      <ModalWrapper>
        { toast ?
          <Toast
            close={ toast.funcao }
            fullWidth={ true }
            message={ toast.message }
            show={ toast.show }
            type="error"
          /> : null}

        {errosAutoCobranca?.typeError === 'cartaoInvalido' ?
          <WrapperButtonError>
            <Button
              invertido
              onClick={ onClickAcaoSecundaria }
              target="_self"
              tema={ Button.BOTAO_CURADORIA }
            >
              Fechar
            </Button>
          </WrapperButtonError>
          :
          <>
            <Titulo>
              { TITULO }
            </Titulo>

            <Descricao>
              { DESCRICAO }
            </Descricao>

            <TextoCVV>
              { FRASE_APOIO_CVV }
            </TextoCVV>

            <CVVInput
              botao={ false }
              handleCVV={ dados => {
                setCVV( dados.numeroCVV )
                setValido( dados.valido )
              } }
              isCenter
              titulo={ false }
            />

            <WrapperButton>
              <Button
                invertido
                onClick={ onClickAcaoSecundaria }
                target="_self"
                tema={ Button.BOTAO_CURADORIA }
              >
                { acaoSecundariaTitulo }
              </Button>

              <Button
                disabled={ !valido }
                onClick={ () => {
                  onClickAcaoPrimaria( CVV )
                } }
                target="_self"
                tema={ Button.BOTAO_CURADORIA }
              >
                { acaoPrimariaTitulo }
              </Button>
            </WrapperButton>
          </>}
      </ModalWrapper>
    </Modal>
  )
}

ModalCVV.propTypes = {
  'acaoPrimariaTitulo': string.isRequired,
  'acaoSecundariaTitulo': string.isRequired,
  'descricao': string,
  'errosAutoCobranca': string,
  'fecharModal': func,
  'getValorCVV': func,
  'limparErros': func,
  'onClickAcaoPrimaria': func.isRequired,
  'onClickAcaoSecundaria': func.isRequired,
  'open': bool,
  'loading': bool.isRequired,
}

ModalCVV.defaultProps = {
  'descricao': null,
  'errosAutoCobranca': null,
  'fecharModal': null,
  'getValorCVV': null,
  'limparErros': null,
  'open': false
}

export default ModalCVV
